import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Loader from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

/*
  This is the config file for i18next, the localization library.
  To access it from your component,
  if it's class:
    withTranslation()(Class) and then in render:
    this.props.t('namespace:key')
  if it's function:
    const { t } = useTranslation() and then in return:
    t('namespace:key')
*/

i18n
  // middleware that loads translations from /public/locales
  // does this dynamically once the language is detected
  .use(Loader)
  // middleware that identifies the language for user
  // checks cookies, browser lang, etc...
  .use(LanguageDetector)
  // middleware that connectes lib to react wrappers and components
  .use(initReactI18next)
  .init({
    ns: [ 'TopBar', 'Cabinet' ], // filenames to load translation from
    defaultNS: 'TopBar', // the default namespace to be loaded first
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json' // locales location
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
